import { useMutation, useQueryClient } from 'react-query';

import { putUserPageData as put } from 'api/users/putUserPageData';

const usePutUserPageData = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: putUserPageData,
    isLoading,
  } = useMutation(put, {
    onSuccess: () => {
      queryClient.invalidateQueries('UsersPageData');
    },
  });

  return {
    isSuccess,
    putUserPageData,
    isLoading,
  };
};

export default usePutUserPageData;
